// React binding for the sound settings store. Components that show a
// volume slider / mute toggle (SettingsScreen, the /?sfx page) read
// through this; everything else just imports playSfx and fires.

import { useSyncExternalStore } from 'react'
import {
  getSoundSettings,
  subscribeSoundSettings,
  setVolume,
  setMuted,
  toggleMuted,
  setShopBed,
  setBattleBed,
  type SoundSettings,
} from './soundSettings'

export function useSoundSettings(): SoundSettings & {
  setVolume: (v: number) => void
  setMuted: (m: boolean) => void
  toggleMuted: () => void
  setShopBed: (id: string) => void
  setBattleBed: (id: string) => void
} {
  const settings = useSyncExternalStore(subscribeSoundSettings, getSoundSettings, getSoundSettings)
  return { ...settings, setVolume, setMuted, toggleMuted, setShopBed, setBattleBed }
}
